// Services data for Integrand Analytics - Clik.ai style

export const servicesData = {
  loanOrigination: {
    id: 'loan-origination',
    title: 'Loan Origination & Servicing',
    services: [
      {
        title: 'Agency Underwriting Support',
        description: 'Live collaboration with your team to populate Fannie Mae & Freddie Mac workbooks.',
        link: '/services/agency-underwriting',
        features: [
          'Fannie Mae workbook population',
          'Freddie Mac templates support',
          'Real-time collaboration',
          'Quality assurance review'
        ]
      },
      {
        title: 'Custom Financial Model Development',
        description: 'Bespoke Excel-based models built by CRE experts, tailored to your deal.',
        link: '/services/financial-model',
        features: [
          'Deal-specific modeling',
          'Sensitivity analysis',
          'Scenario planning',
          'Investment return calculations'
        ]
      },
      {
        title: 'Disbursement & PCNA Support',
        description: 'Accurate loan disbursement processing and PCNA reporting with expert oversight.',
        link: '/services/disbursement-support',
        features: [
          'Disbursement processing',
          'PCNA report generation',
          'Compliance verification',
          'Documentation management'
        ]
      },
      {
        title: 'Loan Due Diligence',
        description: 'Comprehensive due diligence services for commercial mortgage loans and CMBS transactions.',
        link: '/services/loan-due-diligence',
        features: [
          'Document review & analysis',
          'Risk assessment',
          'Compliance verification',
          'Report generation'
        ]
      }
    ]
  },
  leaseAdministration: {
    id: 'lease-administration',
    title: 'Lease & Data Administration',
    services: [
      {
        title: 'Lease Abstraction & Audit',
        description: 'Extract and audit critical lease data with expert-driven review and validation.',
        link: '/services/lease-abstraction',
        features: [
          'Key terms extraction',
          'Clause identification',
          'Data validation',
          'Audit trail maintenance'
        ]
      },
      {
        title: 'Loan Onboarding & Data Digitization',
        description: 'Convert legacy loan data from documents into structured, reliable records in bulk.',
        link: '/services/loan-onboarding',
        features: [
          'Legacy data conversion',
          'Bulk processing',
          'Data standardization',
          'Quality control'
        ]
      },
      {
        title: 'CAM Reconciliations',
        description: 'Expert common area maintenance reconciliation and recovery audit services.',
        link: '/services/cam-reconciliations',
        features: [
          'Expense verification',
          'Recovery calculations',
          'Tenant billing support',
          'Year-end reconciliation'
        ]
      },
      {
        title: 'Lease Administration Support',
        description: 'Comprehensive lease administration services including critical date tracking and compliance.',
        link: '/services/lease-admin-support',
        features: [
          'Critical date management',
          'Rent roll maintenance',
          'Escalation tracking',
          'Option management'
        ]
      }
    ]
  },
  consulting: {
    id: 'consulting',
    title: 'Consulting & Tech Solutions',
    services: [
      {
        title: 'Salesforce Customization & Integration',
        description: 'Configure and integrate Salesforce to match your CRE business needs.',
        link: '/services/salesforce-consulting',
        features: [
          'Custom configuration',
          'Workflow automation',
          'Third-party integration',
          'User training & support'
        ]
      },
      {
        title: 'Custom Reporting & Dashboards',
        description: 'Dynamic, customized dashboards tailored to your specific CRE KPIs.',
        link: '/services/reporting-dashboards',
        features: [
          'KPI visualization',
          'Real-time analytics',
          'Custom report builder',
          'Automated scheduling'
        ]
      },
      {
        title: 'CRE Technology Consulting',
        description: 'Strategic guidance on CRE technology adoption, implementation, and scaling.',
        link: '/services/cre-tech-consulting',
        features: [
          'Technology assessment',
          'Vendor selection',
          'Implementation roadmap',
          'Change management'
        ]
      },
      {
        title: 'ARGUS Modeling Services',
        description: 'Professional ARGUS cash flow modeling and valuation analysis for commercial properties.',
        link: '/services/argus-modeling',
        features: [
          'Cash flow modeling',
          'Valuation analysis',
          'Scenario testing',
          'Model audit & review'
        ]
      }
    ]
  }
};

export const howItWorks = [
  {
    step: 1,
    title: 'Share Your Requirements',
    description: 'Upload your documents, share project details, and define your specific needs and timelines.'
  },
  {
    step: 2,
    title: 'Expert Processing',
    description: 'Our CRE specialists analyze, process, and validate data with industry-leading accuracy.'
  },
  {
    step: 3,
    title: 'Receive Results',
    description: 'Get comprehensive deliverables, detailed reports, and ongoing support for your projects.'
  }
];

export const faqData = [
  {
    question: 'How does Integrand Analytics pricing model work?',
    answer: 'We offer flexible pricing models including per-project, retainer-based, and volume-based pricing. Our team works with you to find the most cost-effective solution for your specific needs.'
  },
  {
    question: 'What types of documents can Integrand process?',
    answer: 'We process a wide range of CRE documents including rent rolls, operating statements, lease agreements, loan documents, appraisals, and property condition reports.'
  },
  {
    question: 'How accurate is your data extraction and analysis?',
    answer: 'Our expert-driven processes achieve 99%+ accuracy through multiple quality control checkpoints and experienced CRE analysts reviewing all deliverables.'
  },
  {
    question: 'Can you customize financial models to match our company format?',
    answer: 'Absolutely. We specialize in creating bespoke financial models tailored to your specific requirements, templates, and analysis frameworks.'
  },
  {
    question: 'What kind of support is included?',
    answer: 'All engagements include dedicated project management, regular status updates, quality assurance, and responsive communication with our expert team.'
  },
  {
    question: 'How quickly can we get started with Integrand?',
    answer: 'Most clients can begin their first project within 48-72 hours of initial engagement. We offer rapid onboarding and can scale resources based on your timeline needs.'
  }
];
